import { Link } from "react-router-dom";
import { Star, MapPin, PauseCircle } from "lucide-react";
import { Badge } from "./ui/badge";

export default function HandymanCard({ h, categoryMap = {} }) {
  const inactive = h.handyman_active === false;
  return (
    <Link
      to={`/handymen/${h.user_id}`}
      data-testid={`handyman-card-${h.user_id}`}
      className={`card-hover block bg-[#131C2E] rounded-2xl border border-[#1F2A40] overflow-hidden ${inactive ? "opacity-70" : ""}`}
    >
      <div className="aspect-[4/3] bg-beige overflow-hidden relative">
        {h.photo_url ? (
          <img
            src={h.photo_url}
            alt={h.name}
            className={`w-full h-full object-cover transition-transform duration-500 hover:scale-105 ${inactive ? "grayscale" : ""}`}
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center text-charcoal/40">No photo</div>
        )}
        {inactive && (
          <div className="absolute top-3 left-3">
            <Badge className="rounded-full bg-[#0B1220]/85 backdrop-blur text-charcoal border border-[#1F2A40] flex items-center gap-1" data-testid={`inactive-badge-${h.user_id}`}>
              <PauseCircle className="w-3 h-3" /> Not accepting bookings
            </Badge>
          </div>
        )}
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-display text-xl text-charcoal">{h.name}</h3>
            <p className="text-sm text-charcoal/60 flex items-center gap-1 mt-0.5">
              <MapPin className="w-3.5 h-3.5" /> {h.campus}
            </p>
          </div>
          <div className="text-right">
            <div className="flex items-center gap-1 text-sm">
              <Star className="w-4 h-4 fill-terracotta text-terracotta" />
              <span className="font-medium">{Number(h.rating || 0).toFixed(1)}</span>
              <span className="text-charcoal/50">({h.review_count || 0})</span>
            </div>
            <p className="text-terracotta font-semibold mt-1">${h.hourly_rate}/hr</p>
          </div>
        </div>
        <p className="text-sm text-charcoal/70 mt-3 line-clamp-2">{h.bio}</p>
        <div className="flex flex-wrap gap-1.5 mt-3">
          {(h.services || []).slice(0, 3).map((s) => (
            <Badge key={s} variant="secondary" className="rounded-full bg-beige text-charcoal/80 hover:bg-beige/70">
              {categoryMap[s] || s}
            </Badge>
          ))}
        </div>
      </div>
    </Link>
  );
}
